module.exports = __webpack_public_path__ + "img/icon_sprite.c932cce0.svg";